module.exports = __webpack_public_path__ + "img/dp-yq-icon.70abc305.png";